import { Box } from "@mui/material";
import PropTypes from "prop-types";

const FormActions = ({ startActions, endActions, sx = {} }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column",
          md: "row",
        },
        justifyContent: "space-between",
        alignItems: {
          xs: "stretch",
          md: "center",
        },
        gap: 2,
        width: "100%",
        paddingBottom: {
          xs: 12,
          sm: 8,
          md: 0,
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          gap: 2,
          width: {
            xs: "100%",
            md: "auto",
          },
          "& .MuiButton-root": {
            width: {
              xs: "100%",
              md: "auto",
            },
          },
        }}
      >
        {startActions}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: {
            xs: "stretch",
            md: "flex-end",
          },
          width: {
            xs: "100%",
            md: "auto",
          },
          "& .MuiButton-root": {
            width: {
              xs: "100%",
              md: "auto",
            },
          },
        }}
      >
        {endActions}
      </Box>
    </Box>
  );
};

FormActions.propTypes = {
  startActions: PropTypes.node,
  endActions: PropTypes.node,
  sx: PropTypes.object,
};

export default FormActions;
